import React from "react";
import "./Navbar.css";
import { Link } from "react-router-dom";
import ComingSoon from "./ComingSoon";

export default function Navbar() {
  const closeMobileMenu = (event) => {
    // Keep dropdown toggles open so their menus can be selected.
    if (event?.target.closest(".dropdown-toggle")) return;

    const mobileMenu = document.getElementById("navbarSupportedContent");
    const menuToggler = document.querySelector(
      '[data-bs-target="#navbarSupportedContent"]'
    );

    if (window.innerWidth < 992 && mobileMenu?.classList.contains("show")) {
      mobileMenu.classList.remove("show");
      menuToggler?.setAttribute("aria-expanded", "false");
    }
  };


  return (

    <nav className="navbar sticky-top navbar-expand-lg navbar-success shadow-sm">


      <div className="container-fluid">
        <Link className="navbar-brand fw-bold fs-3" to="/home">
          <i className="bi bi-moon-stars-fill me-2"></i>
          Misbahi
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div
          className="collapse navbar-collapse"
          id="navbarSupportedContent"
          onClick={closeMobileMenu}
        >
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">

            {/* Library Dropdown */}
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="/"
                id="libraryDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="bi bi-journal-bookmark-fill me-1"></i>
                Library
              </a>

              <ul
                className="dropdown-menu"
                aria-labelledby="libraryDropdown"
              >
                <li>
                  <Link className="dropdown-item" to="/library/pdf">
                    <i className="bi bi-file-earmark-pdf me-2"></i>
                    Book Collection
                  </Link>
                </li>

                <li>
                  <Link className="dropdown-item" to="/library/audio">
                    <i className="bi bi-mic-fill me-2"></i>
                    Audio Library
                  </Link>
                </li>
              </ul>
            </li>

            {/* Islamic Service Dropdown */}
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="islamicServiceDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="bi bi-building me-1"></i>
                Islamic Service
              </a>

              <ul
                className="dropdown-menu"
                aria-labelledby="islamicServiceDropdown"
              >
                <li>
                  <Link
                    className="dropdown-item"
                    to="/islamicservice/mosque"

                  >
                    <i className="bi bi-building me-2"></i>
                    Mosque
                  </Link>
                </li>

                <li>
                  <Link
                    className="dropdown-item"
                    to="Comingsoon"

                  >
                    <i className="bi bi-mortarboard-fill me-2"></i>
                    Darul Uloom
                  </Link>
                </li>

                <li>
                  <Link
                    className="dropdown-item"
                    to="Comingsoon"

                  >
                    <i className="bi bi-images me-2"></i>
                    Gallery
                  </Link>
                </li>
              </ul>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/misbahidarul-ifta">
                <i className="bi bi-pencil-square me-1"></i>
                Misbahi Darul-Ifta
              </Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/Comingsoon">
                <i className="bi bi-people-fill me-1"></i>
                Department
              </Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/Comingsoon">
              <i className="bi bi-mortarboard-fill"></i>
                Admission now
              </Link>
            </li>
          </ul>

          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <Link className="nav-link" to="/about">
                <i className="bi bi-info-circle-fill me-1"></i>
                About
              </Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/contactus">
                <i className="bi bi-telephone-fill me-1"></i>
                Contact Us
              </Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/donation">
                <i className="bi bi-cash-stack me-1"></i>
                Donation
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
